// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__OQYBZ","active":"overlay_active__qJ89+"};